import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'content-video-player',
  name: '短视频播放器',
  icon: '播',
  group: '短视频详情页',
  description: '展示视频、封面、标题和作者信息。',
  defaultProps: {
    autoplay: true,
    muted: false,
    loop: true,
    showControls: true,
    objectFit: 'cover',
    showCaption: true
  }
}
